/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Tag,
  Modal,
  Form,
  InputNumber,
  Select,
} from "antd";
import {
  ALL_BOOKING_REFUND,
  BOOKING_REFUND_CANCELLED_BOOKINGS,
  CREATE_BOOKING_REFUND,
  UPDATE_BOOKING_REFUND_STATUS,
  BOOKING_REFUND_RAZORPAY,
  DELETE_BOOKING_REFUND,
} from "../../constants/api";
import { CURRENCY, PAYMENT_METHOD } from "../../constants/constent";
import LS_SERVICE from "../../utils/localStorage";
import moment from "moment";

const STATUS_COLORS = {
  Pending: "orange",
  Approved: "blue",
  Rejected: "red",
  Processed: "green",
  Success: "green",
};

function BookingRefundTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  // Create modal
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [cancelledBookings, setCancelledBookings] = useState([]);
  const [form] = Form.useForm();

  useLayoutEffect(() => {
    getList();
  }, []);

  // Load cancelled bookings (pending refund) for the create dropdown.
  const loadCancelledBookings = () => {
    const successFn = function (res) {
      setCancelledBookings(res.status === true ? res.data : []);
    };
    const errorFn = function () {
      setCancelledBookings([]);
    };
    getAPI(BOOKING_REFUND_CANCELLED_BOOKINGS, successFn, errorFn, {});
  };

  // Auto-fill amount / method / reason when a booking is picked.
  const handleBookingSelect = (bookingId) => {
    const b = cancelledBookings.find((x) => x.id === bookingId);
    if (!b) return;
    form.setFieldsValue({
      amount: b.advance_amount || 0,
      refund_method: b.payment_method || undefined,
      reason: b.reason || "Booking cancelled",
    });
  };

  const openCreate = () => {
    form.resetFields();
    loadCancelledBookings();
    setIsCreateOpen(true);
  };

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setState(data.data);
        setFilteredData(data.data);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_BOOKING_REFUND, successFn, errorFn, {});
  };

  const handleCreate = (values) => {
    setLoading(true);
    const data = {
      booking_id: values.booking_id,
      amount: values.amount,
      refund_method: values.refund_method ?? "",
      reason: values.reason ?? "",
    };
    const successFn = function (res) {
      if (res.status === true) {
        setLoading(false);
        setIsCreateOpen(false);
        form.resetFields();
        getList();
        displayMessage(SUCCESS_MESSAGE, res.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to create refund request");
    };
    postAPI(CREATE_BOOKING_REFUND, data, successFn, errorFn);
  };

  const updateStatus = (id, status) => {
    setLoading(true);
    const data = {
      id: id,
      status: status,
      processed_by: LS_SERVICE.get("name") ?? "",
    };
    const successFn = function (res) {
      if (res.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, res.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to update refund status");
    };
    postAPI(UPDATE_BOOKING_REFUND_STATUS, data, successFn, errorFn);
  };

  const initRazorpayRefund = (id) => {
    setLoading(true);
    const successFn = function (res) {
      if (res.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, res.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to initiate Razorpay refund");
    };
    postAPI(BOOKING_REFUND_RAZORPAY, { id: id }, successFn, errorFn);
  };

  const deleteData = (id) => {
    setLoading(true);
    const successFn = function (res) {
      if (res.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, res.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_BOOKING_REFUND, { id: id }, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const lower = value.toLowerCase();
    const filtered = state.filter((row) => {
      const ref = (row.multi_book_id ?? "").toString().toLowerCase();
      const guest = (row.booking?.user?.name ?? "").toLowerCase();
      const status = (row.status ?? "").toLowerCase();
      return (
        ref.includes(lower) ||
        guest.includes(lower) ||
        status.includes(lower) ||
        String(row.booking_id).includes(lower)
      );
    });
    setFilteredData(filtered);
  };

  const columns = [
    { title: "Sno", dataIndex: "ID", width: 60 },
    { title: "Booking Ref", dataIndex: "ref", width: 150 },
    { title: "Guest", dataIndex: "guest", width: 150 },
    { title: "Amount", dataIndex: "amount", width: 110 },
    { title: "Method", dataIndex: "method", width: 120 },
    { title: "Reason", dataIndex: "reason", width: 180 },
    { title: "Status", dataIndex: "status", width: 110 },
    { title: "Requested On", dataIndex: "created", width: 150 },
    { title: "Action", dataIndex: "Action", width: 220 },
  ];

  const dataSource = filteredData.map((row, index) => ({
    key: index,
    ID: index + 1,
    ref: row.multi_book_id || row.booking?.order_id || `#${row.booking_id}`,
    guest: row.booking?.user?.name ?? "N/A",
    amount: `${CURRENCY} ${Number(row.amount ?? 0).toFixed(2)}`,
    method: row.refund_method || "N/A",
    reason: row.reason || "—",
    status: (
      <Tag color={STATUS_COLORS[row.status] || "default"}>{row.status}</Tag>
    ),
    created: row.created_at
      ? moment(row.created_at).format("DD MMM YYYY, h:mm A")
      : "—",
    Action: (
      <Space wrap>
        {row.status === "Pending" && (
          <>
            <Button
              type="primary"
              size="small"
              disabled={loading}
              onClick={() => updateStatus(row.id, "Approved")}
            >
              Approve
            </Button>
            <Button
              danger
              size="small"
              disabled={loading}
              onClick={() => updateStatus(row.id, "Rejected")}
            >
              Reject
            </Button>
          </>
        )}
        {row.status === "Approved" && (
          <Button
            size="small"
            disabled={loading}
            onClick={() => updateStatus(row.id, "Processed")}
          >
            Mark Processed
          </Button>
        )}
        {row.status === "Processed" && (
          <Button
            type="primary"
            size="small"
            disabled={loading}
            onClick={() => updateStatus(row.id, "Success")}
          >
            Mark Success
          </Button>
        )}
        {/* Real online refund — only when the booking was paid via Razorpay
            and the refund isn't already completed. */}
        {row.razorpay_eligible &&
          !["Success", "Processed", "Rejected"].includes(row.status) && (
            <Popconfirm
              title="Refund via Razorpay"
              description={`This will refund ${CURRENCY} ${Number(
                row.amount ?? 0
              ).toFixed(2)} to the guest through Razorpay. Continue?`}
              onConfirm={() => initRazorpayRefund(row.id)}
              okText="Yes, refund"
              cancelText="No"
            >
              <Button type="primary" size="small" disabled={loading}>
                Refund via Razorpay
              </Button>
            </Popconfirm>
          )}
        {LS_SERVICE.get("user_type") === "superAdmin" && (
          <Popconfirm
            title="Delete refund"
            description="Are you sure you want to delete this refund record?"
            onConfirm={() => deleteData(row.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger size="small">
              Delete
            </Button>
          </Popconfirm>
        )}
      </Space>
    ),
  }));

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Booking Refunds"
            extra={
              <Space>
                <Input
                  placeholder="Search by Ref / Guest / Status"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 280 }}
                />
                <Button type="primary" onClick={openCreate}>
                  Create Refund
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={dataSource}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>

      {/* Create Refund Modal */}
      <Modal
        title="Create Refund Request"
        open={isCreateOpen}
        onCancel={() => setIsCreateOpen(false)}
        onOk={() => form.submit()}
        okText="Create"
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical" onFinish={handleCreate}>
          <Form.Item
            name="booking_id"
            label="Cancelled Booking"
            rules={[{ required: true, message: "Please select a booking" }]}
          >
            <Select
              showSearch
              placeholder="Select a cancelled booking"
              optionFilterProp="children"
              onChange={handleBookingSelect}
              notFoundContent="No cancelled bookings pending refund"
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {cancelledBookings.map((b) => (
                <Select.Option key={b.id} value={b.id}>
                  {b.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="amount"
            label="Refund Amount"
            rules={[{ required: true, message: "Please enter the refund amount" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              prefix={CURRENCY}
              placeholder="Enter amount"
            />
          </Form.Item>
          <Form.Item name="refund_method" label="Refund Method">
            <Select placeholder="Select method" allowClear>
              {PAYMENT_METHOD.map((m) => (
                <Select.Option key={m.value} value={m.value}>
                  {m.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="reason" label="Reason">
            <Input.TextArea rows={3} placeholder="Reason for refund (optional)" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default BookingRefundTable;
